import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Bind } from './model';

type ClientBind = {
    value: Bind;
    label: string;
};

type Props = {
    binds: Bind[];
    label: string;
    bindSelected: (bind: Bind | undefined) => void;
};

const BindSelector = ({ binds, label, bindSelected }: Props) => {
    const options: ClientBind[] = binds
        ? binds.map((bind) => ({
              value: bind,
              label: bind.name,
          }))
        : [];

    return (
        <Autocomplete
            fullWidth
            sx={{ p: '2px' }}
            options={options}
            onChange={(event, value) => bindSelected(value?.value)}
            disabled={!binds.length}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    label={label}
                />
            )}
        />
    );
};

export default BindSelector;
